import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProductService } from 'src/app/services/product-service/product.service';
import { ShopServiceService } from 'src/app/services/shop-service.service';
import { Product } from '../../models/type/product.model';
import { Shop } from '../../models/type/shop.model';
import { Type } from '../../models/type/type.model';

@Component({
  selector: 'app-logged-home',
  templateUrl: './logged-home.page.html',
  styleUrls: ['./logged-home.page.scss'],
})
export class LoggedHomePage implements OnInit {
  // shops: Shop[] = [];
  shops = [];
  products: Product[] = [];
  types: Type[] = [];
  constructor(
    private shopService: ShopServiceService,
    private productService: ProductService,
    private router: Router
  ) {}

  ngOnInit() {
    // this.shops = this.shopSer.getShops();
    this.shopService.getShops().subscribe((res) => {
      this.shops = res.map((shop) => {
        shop.payload.doc.data() as Shop;
      });
    });

    // this.products = this.produstService.getPoducts();

    this.productService.getPoducts().subscribe((res) => {
      this.products = res.map(
        (product) => product.payload.doc.data() as Product
      );
    });

    this.types = [
      {
        id: 1,
        head: 'All',
        image: 'assets/all.png',
        active: true,
      },
      {
        id: 2,
        head: 'Cuisine',
        image: 'assets/dish.png',
        active: false,
      },
      {
        id: 3,
        head: 'Essentials',
        image: 'assets/house.png',
        active: false,
      },
      {
        id: 4,
        head: 'Beverages',
        image: 'assets/scoot.png',
        active: false,
      },
    ];

    // /**
    // this.types[0].active = true;
    // this.types[1].active = false;
    // this.types[2].active = false;
    // this.types[3].active = false;
    // */
  }

  goToCategory(id: number) {
    if (id !== 1) {
      this.router.navigate(['home/category', id]);
    }
  }

  goToProfile() {
    this.router.navigate(['user-home']);
  }

  goHome() {
    this.router.navigate(['home/landing']);
  }
}
